import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { encodedStudentInfo } from "../../App";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import Footer from "../shared/Footer";
import config from "../../config";
import CRC32 from "crc-32";
import ScrutinyPDF from "../ScrutinyPDF";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";

function Payment() {
  const [loading, setLoading] = useState(true);
  const [feeDetails, setFeeDetails] = useState(null);
  const navigate = useNavigate();
  const [environment, setEnvironment] = useState("YES");

  const movetoedit = () => {
    navigate("/student-info");
  };
  useEffect(() => {
    if(sessionStorage.getItem("CLASS_12_PAYMENT_ON_OFF") ==='OFF'){ 
      navigate("/dashboard");
      return;
    }
    const fetchFeeDetails = async () => {
      const token = sessionStorage.getItem("tokenclassxii");
      const rollnumber = sessionStorage.getItem("rollnumberxii");
      const rollcode = sessionStorage.getItem("rollcodexii");

      if (!token) {
        navigate("/");
        return;
      }

      try {
        const response = await fetch(
          `${config.API_BASE_URL}/GetStudentSubCountClass12`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ rollcode: rollcode, rollno: rollnumber }),
          }
        );

        if (!response.ok) throw new Error("Failed to fetch fee details");

        const data = await response.json();
        console.log("Fee Details:", data.data);
        setEnvironment(data.data.DEVELOPMENT_MODE);
        setFeeDetails(data.data);
      } catch (error) {
        console.error("Error fetching fee details:", error);
      } finally {
        setLoading(false);
      }
    };

    const paymentStatus = sessionStorage.getItem("PaymentStatus");
    if (paymentStatus === "NO" || paymentStatus === "F") {
      fetchFeeDetails();
    } else {
      navigate("/dashboard");
    }
  }, [navigate]);

  const formatNumber = (number, decimals) => {
    return parseFloat(number).toFixed(decimals);
  };

  const generateChecksum = (message, secretKey) => {
    const fullMessage = message + "|" + secretKey;
    return CRC32.str(fullMessage) >>> 0; // ensure unsigned
  };

  const handleProceedToPayment = () => {
    const orderId = feeDetails?.ORDER_ID || "N/A";
    const customerId =
      sessionStorage.getItem("rollcodexii") +
      sessionStorage.getItem("rollnumberxii");
    const transactionAmount = feeDetails?.AMOUNT;
    const requestDateTime = new Date()
      .toLocaleDateString("en-GB")
      .split("/")
      .join("-");

    const isProd = environment === "YES";

    const url = isProd
      ? config.PAYMENT_LINK_DEV
      : config.PAYMENT_LINK_PRODUCTION;
    const responseUrl = isProd
      ? config.PAYMENT_RESPONSE_URL_DEV
      : config.PAYMENT_RESPONSE_URL_PRODUCTION;
    const serviceId = isProd
      ? config.SERVICE_ID_DEV
      : config.SERVICE_ID_PRODUCTION;
    const merchantId = isProd
      ? config.MERCHANT_ID_DEV
      : config.MERCHANT_ID_PRODUCTION;
    const secretKey = isProd
      ? config.SECRET_KEY_DEV
      : config.SECRET_KEY_PRODUCTION;

    const currency = config.REACT_APP_CURRENCY || "INR";
    const messageType = config.MESSAGE_TYPE || "AR";
    const additionalFields = ["test1", "test2", "test3", "test4", "test5"];
    const formattedAmount = formatNumber(transactionAmount, 2);

    const msg = [
      messageType,
      merchantId,
      serviceId,
      orderId,
      customerId,
      formattedAmount,
      currency,
      requestDateTime,
      responseUrl,
      responseUrl,
      ...additionalFields,
    ].join("|");

    const checksum = generateChecksum(msg, secretKey);

    const form = document.createElement("form");
    form.name = "URL";
    form.method = "POST";
    form.enctype = "multipart/formdata";
    form.action = url;

    const appendHidden = (name, value, addBreaks = true) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      input.setAttribute("readonly", ""); // Correctly add readonly
      form.appendChild(input);

      if (addBreaks) {
        form.appendChild(document.createElement("br"));
        form.appendChild(document.createElement("br"));
      }
    };

    appendHidden("messageType", messageType);
    appendHidden("merchantId", merchantId);
    appendHidden("serviceId", serviceId);
    appendHidden("currencyCode", currency);
    appendHidden("successUrl", responseUrl);
    appendHidden("failUrl", responseUrl);
    appendHidden("orderId", orderId);
    appendHidden("customerId", customerId);
    appendHidden("transactionAmount", formattedAmount);
    appendHidden("requestDateTime", requestDateTime);

    // Add <br><br> for all but the last additional field
    additionalFields.forEach((field, index) => {
      const isLast = index === additionalFields.length - 1;
      appendHidden(`additionalField${index + 1}`, field, !isLast);
    });

    appendHidden("checksum", checksum, false); // No breaks after last input

    console.log("Generated Payment Form HTML:");
    console.log(form.outerHTML);
    debugger;
    // Uncomment to actually submit
    document.body.appendChild(form);
    form.submit();
  };
  // useEffect(() => {
  //   const paymentresponse = () => {
  //     alert("Payment Response"); 
  //   }
  //   paymentresponse();
  //  }, []);
  const handleDownloadApplication = async (e) => {
    e.preventDefault();
    try {
      const token = sessionStorage.getItem("tokenclassxii");
      const rollno = sessionStorage.getItem("rollnumberxii");
      const rollcode = sessionStorage.getItem("rollcodexii");

      const response = await fetch(
        `${config.API_BASE_URL}/ScrutinyReceiptReportClass12`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ROLLCODE: rollcode, ROLLNO: rollno }),
        }
      );

      if (!response.ok) throw new Error("Failed to fetch scrutiny data");
      const data = await response.json();

      const blob = await pdf(<ScrutinyPDF data={data.data} />).toBlob();
      saveAs(blob, "scrutiny-application.pdf");
    } catch (err) {
      console.error("PDF download error:", err);
    }
  };
  return (
    <>

      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}

      {!loading && (
        <div className="container-scroller">
          <Navbar />
          <div className="container-fluid page-body-wrapper">
            <Sidebar />
            <div className="main-panel">
              <div
                className="content-wrapper"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <div className="row">
                  <div className="col-md-3"></div>
                  <div className="col-md-6 mb-4 stretch-card">
                    <div className="card">
                      <div className="card-header bg-brown">
                        <h3 className="mb-0 p-2 text-center text-white">
                          FEES SUMMARY
                        </h3>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12 mb-5 mt-4">
                            <table className="table table-bordered">
                              <tbody>
                                <tr>
                                  <td>NAME</td>
                                  <td className="fw-bold">
                                    {sessionStorage.getItem("candidatenamexii")}
                                  </td>
                                </tr>
                                <tr>
                                  <td>ORDER ID</td>
                                  <td className="fw-bold">{feeDetails?.ORDER_ID || "N/A"}</td>
                                </tr>
                              
                                <tr>
                                  <td>ROLL CODE</td>
                                  <td className="fw-bold">
                                    {sessionStorage.getItem("rollcodexii")}
                                  </td>
                                </tr>
                                  <tr>
                                  <td>ROLL NUMBER</td>
                                  <td className="fw-bold">
                                    {sessionStorage.getItem("rollnumberxii")}
                                  </td>
                                </tr>
                                <tr>
                                  <td>NO. OF SUBJECTS</td>
                                  <td className="fw-bold">
                                    {feeDetails?.SUBJECT_YES_COUNT || "N/A"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>TOTAL FEES</td>
                                  <td className="fw-bold">
                                    {feeDetails?.AMOUNT || "N/A"} /-
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12 text-center">
                            <button
                              className="btn btn-primary"
                              onClick={(e) => {
                                e.preventDefault();
                                movetoedit();
                              }}
                              style={{ marginBottom: "10px" }}
                            >
                              <i className="fa fa-edit"></i> Edit my Application
                            </button>
                            &nbsp;&nbsp;
                            <button
                              href=""
                              className="btn btn-warning"
                              onClick={handleDownloadApplication}
                              style={{ marginBottom: "10px" }}

                            >
                              <i className="fa fa-download"></i>&nbsp;Download Application
                            </button> &nbsp;&nbsp;
                            <button

                              className="btn btn-success"
                              onClick={(e) => {
                                e.preventDefault();
                                handleProceedToPayment();
                              }}
                              style={{ marginBottom: "10px" }}
                            >
                              You Can Proceed For Payment{" "}
                              <i className="fa fa-arrow-right"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3"></div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Payment;


